@Inject('appFactory')
export default class TableService {
  initConfig({ configName }) {
    const tableConfig = this.appFactory.deps.config.tableConfig[configName]
      ? this.appFactory.deps.config.tableConfig[configName].split(',')
      : void 0;

    const getHeaders = (headers) =>
      tableConfig
        ? headers.reduce((previousValue, currentValue) => {
            if (currentValue && (!currentValue.field || tableConfig.includes(currentValue.field))) {
              previousValue.push(currentValue);
            }
            return previousValue;
          }, [])
        : headers;

    const isAvailableField = (field) => (tableConfig ? tableConfig.includes(field) : true);

    return {
      getHeaders,
      isAvailableField,
    };
  }

  getHeaderTextForField(headers, field) {
    if (headers) {
      const header = headers.find((header) => header && header.field === field);
      return header ? header.text : '';
    }
    return '';
  }

  getHeaderTextAlignmentForField(headers, field) {
    if (headers) {
      const header = headers.find((header) => header && header.field === field);
      return header ? header.textAlignment : '';
    }
    return '';
  }

  getFirstFieldName(headers) {
    return headers && headers.length > 0 ? headers[0].field : void 0;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/grid/table-service.js